var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('slice-blurb-video');
import { first } from 'lodash';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { classNames } from '../../utils/cn';
import { ContentNode } from './content-node';
import { VideoImage } from './video-image';
import { useColorInfo } from '../../hooks/use-color-info';
import { LinkButton } from '../elements/link-button';
import { coalesce } from '../../utils/coalesce';
import { useLang } from '../../hooks/use-lang';
export var SliceBlurbVideoDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 400;\n  "], ["\n    font-size: 1em;\n    font-weight: 400;\n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  "]))),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 66.66667%;\n  "], ["\n    width: 66.66667%;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "em;\n    font-weight: 300;\n    color: inherit;\n    line-height: 1.25em;\n    font-weight: 500;\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    margin-top: 0;\n\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: ", "em;\n    font-weight: 300;\n    color: inherit;\n    line-height: 1.25em;\n    font-weight: 500;\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n    margin-top: 0;\n\n    ", "\n  "])), theme.FONT('heading'), 30 / 18, theme.UNIT(8), theme.UNIT(8), function (_a) {
    var _borderColor = _a._borderColor;
    return _borderColor && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.H_DOT_BG_END(_borderColor, 2, 6));
  }),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", "em;\n    padding-right: ", ";\n  "], ["\n    font-size: ", "em;\n    padding-right: ", ";\n  "])), 30 / 18, theme.UNIT(8)),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 38 / 18)
});
var ContentStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: 1em;\n    padding-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    padding-bottom: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme.UNIT(8))
});
var VideoImageStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    flex-shrink: 0;\n    align-self: center; \n    width: 100%;\n  "], ["\n    flex-shrink: 0;\n    align-self: center; \n    width: 100%;\n  "]))),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 33.3333%;\n  "], ["\n    width: 33.3333%;\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    width: auto;\n    margin-top: ", ";\n    max-width: 320px;\n    margin-bottom: ", ";\n  "], ["\n    width: auto;\n    margin-top: ", ";\n    max-width: 320px;\n    margin-bottom: ", ";\n  "])), theme.UNIT(4), theme.UNIT(8)),
  tablet: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-bottom: 0;\n  "], ["\n    margin-bottom: 0;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled(ContentEntityRichTitle)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Content: styled(ContentNode)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  VideoImage: styled(VideoImage)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), VideoImageStyles),
  Link: styled(LinkButton)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles)
};
export var SliceBlurbVideo = function SliceBlurbVideo(props) {
  var className = props.className,
      entity = props.entity;
  var video = first(entity.videos);
  var title = entity.title,
      content = entity.content,
      _a = entity.links,
      links = _a === void 0 ? [] : _a;
  var colorInfo = useColorInfo();
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Body, null, React.createElement(My.Title, {
    entity: entity,
    _borderColor: colorInfo.color
  }), React.createElement(My.Content, {
    entity: content
  }), links.map(function (link) {
    return React.createElement(My.Link, {
      isDownload: link.isDownload,
      key: link.id,
      href: coalesce(link, ['file.file.url', 'page.path', 'url'])
    }, t(coalesce(link, ['label', 'name'])));
  })), video && React.createElement(My.VideoImage, {
    entity: video
  })));
};
SliceBlurbVideo.defaultProps = SliceBlurbVideoDefaultProps;
SliceBlurbVideo.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;